<template>
    <div>
        <h2 class="h1 font-weight-bold">Beliebte Suchen</h2>
        <div class="popular-search-list" style="font-size:16px;padding-bottom:20px">
            <a :href="regionRelativeUrl('/beliebte-suchen/nrw/')">Beliebte Suchen in NRW</a>
            <a :href="regionRelativeUrl('/beliebte-suchen/niedersachsen/')">Beliebte Suchen in Niedersachsen</a>
            <a :href="regionRelativeUrl('/sex/augsburg/')">Sex in Augsburg</a>
            <a :href="regionRelativeUrl('/huren/augsburg/')">Huren in Augsburg</a>
            <a :href="regionRelativeUrl('/sex/berlin/')">Sex in Berlin</a>
            <a :href="regionRelativeUrl('/huren/berlin/')">Huren in Berlin</a>
            <a :href="regionRelativeUrl('/sex/bremen/')">Sex in Bremen</a>
            <a :href="regionRelativeUrl('/huren/bremen/')">Huren in Bremen</a>
            <a :href="regionRelativeUrl('/sex/chemnitz/')">Sex in Chemnitz</a>
            <a :href="regionRelativeUrl('/huren/chemnitz/')">Huren in Chemnitz</a>
            <a :href="regionRelativeUrl('/sex/darmstadt/')">Sex in Darmstadt</a>
            <a :href="regionRelativeUrl('/huren/darmstadt/')">Huren in Darmstadt</a>
            <a :href="regionRelativeUrl('/sex/dresden/')">Sex in Dresden</a>
            <a :href="regionRelativeUrl('/huren/dresden/')">Huren in Dresden</a>
            <a :href="regionRelativeUrl('/sex/erfurt/')">Sex in Erfurt</a>
            <a :href="regionRelativeUrl('/huren/erfurt/')">Huren in Erfurt</a>
            <a :href="regionRelativeUrl('/sex/frankfurt/')">Sex in Frankfurt</a>
            <a :href="regionRelativeUrl('/huren/frankfurt/')">Huren in Frankfurt</a>
            <a :href="regionRelativeUrl('/sex/freiburg-im-breisgau/')">Sex in Freiburg</a>
            <a :href="regionRelativeUrl('/huren/freiburg-im-breisgau/')">Huren in Freiburg</a>
            <a :href="regionRelativeUrl('/sex/halle-saale/')">Sex in Halle (Saale)</a>
            <a :href="regionRelativeUrl('/huren/halle-saale/')">Huren in Halle (Saale)</a>
            <a :href="regionRelativeUrl('/sex/hamburg/')">Sex in Hamburg</a>
            <a :href="regionRelativeUrl('/huren/hamburg/')">Huren in Hamburg</a>
            <a :href="regionRelativeUrl('/sex/heidelberg/')">Sex in Heidelberg</a>
            <a :href="regionRelativeUrl('/huren/heidelberg/')">Huren in Heidelberg</a>
            <a :href="regionRelativeUrl('/sex/karlsruhe/')">Sex in Karlsruhe</a>
            <a :href="regionRelativeUrl('/huren/karlsruhe/')">Huren in Karlsruhe</a>
            <a :href="regionRelativeUrl('/sex/kassel/')">Sex in Kassel</a>
            <a :href="regionRelativeUrl('/huren/kassel/')">Huren in Kassel</a>
            <a :href="regionRelativeUrl('/sex/kiel/')">Sex in Kiel</a>
            <a :href="regionRelativeUrl('/huren/kiel/')">Huren in Kiel</a>
            <a :href="regionRelativeUrl('/sex/leipzig/')">Sex in Leipzig</a>
            <a :href="regionRelativeUrl('/huren/leipzig/')">Huren in Leipzig</a>
            <a :href="regionRelativeUrl('/sex/ludwigshafen-am-rhein/')">Sex in Ludwigshafen-Am-Rhein</a>
            <a :href="regionRelativeUrl('/huren/ludwigshafen-am-rhein/')">Huren in Ludwigshafen-Am-Rhein</a>
            <a :href="regionRelativeUrl('/sex/luebeck/')">Sex in Lübeck</a>
            <a :href="regionRelativeUrl('/huren/luebeck/')">Huren in Lübeck</a>
            <a :href="regionRelativeUrl('/sex/magdeburg/')">Sex in Magdeburg</a>
            <a :href="regionRelativeUrl('/huren/magdeburg/')">Huren in Magdeburg</a>
            <a :href="regionRelativeUrl('/sex/mainz/')">Sex in Mainz</a>
            <a :href="regionRelativeUrl('/huren/mainz/')">Huren in Mainz</a>
            <a :href="regionRelativeUrl('/sex/mannheim/')">Sex in Mannheim</a>
            <a :href="regionRelativeUrl('/huren/mannheim/')">Huren in Mannheim</a>
            <a :href="regionRelativeUrl('/sex/muenchen/')">Sex in München</a>
            <a :href="regionRelativeUrl('/huren/muenchen/')">Huren in München</a>
            <a :href="regionRelativeUrl('/sex/nuernberg/')">Sex in Nuernberg</a>
            <a :href="regionRelativeUrl('/huren/nuernberg/')">Huren in Nuernberg</a>
            <a :href="regionRelativeUrl('/sex/potsdam/')">Sex in Potsdam</a>
            <a :href="regionRelativeUrl('/huren/potsdam/')">Huren in Potsdam</a>
            <a :href="regionRelativeUrl('/sex/regensburg/')">Sex in Regensburg</a>
            <a :href="regionRelativeUrl('/huren/regensburg/')">Huren in Regensburg</a>
            <a :href="regionRelativeUrl('/sex/rostock/')">Sex in Rostock</a>
            <a :href="regionRelativeUrl('/huren/rostock/')">Huren in Rostock</a>
            <a :href="regionRelativeUrl('/sex/saarbruecken/')">Sex in Saarbrücken</a>
            <a :href="regionRelativeUrl('/huren/saarbruecken/')">Huren in Saarbrücken</a>
            <a :href="regionRelativeUrl('/sex/stuttgart/')">Sex in Stuttgart</a>
            <a :href="regionRelativeUrl('/huren/stuttgart/')">Huren in Stuttgart</a>
            <a :href="regionRelativeUrl('/sex/wiesbaden/')">Sex in Wiesbaden</a>
            <a :href="regionRelativeUrl('/huren/wiesbaden/')">Huren in Wiesbaden</a>
        </div>

    </div>
</template>

<script>
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

export default {
    mixins: [regionsUrlMixin]
}
</script>